<template>
  <Popup
    @hide-popup="$emit('hide-popup')"
  >
    <section class="modal-body z1 max-width-4">
      <!-- HEADER -->
      <section class="pt2 pb1 px3 flex justify-between items-center md-sm-xs-flex-column invert">
        <h2 class="my0 md-hide sm-hide xs-hide">Enregistrer le paiement</h2>
        <h4 class="my0 h4 regular">
          Montant total à régler :
          <strong :class="['ml1 align-middle h2', { 'crossed': showPromotion }]">{{ totalPrice }} €</strong>
          <strong v-if="showPromotion" class="ml1 align-middle h2">{{ discountPrice.toFixed(2) }} €</strong>
        </h4>
      </section>
      <!-- END HEADER -->

      <!-- BODY -->
      <section class="white-bg pb2">
        <div class="overflow-auto max-height-1">
          <section
            v-for="(customPayment, customPaymentIndex) in customPayments"
            :key="customPaymentIndex"
            class="relative py2 px3 md-sm-xs-pt3 md-sm-xs-px4 flex justify-between items-end md-sm-xs-flex-wrap md-sm-xs-justify-start md-sm-xs-items-start"
            :class="[
              { 'pt3' : customPaymentIndex == 0 },
              { 'pb3' : customPaymentIndex + 1 == customPayments.length },
              { 'lighter-grey-bg' : customPaymentIndex % 2 !== 0 }
            ]"
          >
            <label class="col-4 lg-col-2 md-col-4 sm-col-6 flex flex-column bold caps h7n">
              Type de paiement*

              <select
                v-model="customPayment.method"
                class="col-12 py1 pl2 mt1 border-select white-bg h7n"
                :class="{ 'red-bd' : !isMethodSelected(customPayment.method)}"
                style="--showSelector: auto;"
                required
              >
                <option value="null" disabled>Choisir un</option>
                <option
                  v-for="(paymentMethod, paymentMethodIndex) in customPaymentMethods"
                  :key="`${customPaymentIndex }_${paymentMethodIndex}`"
                  :value="paymentMethod.value"
                >
                  {{ paymentMethod.text }}
                </option>
              </select>
            </label>

            <label class="col-12 lg-col-6 md-col-12 sm-col-12 ml2 md-sm-xs-ml0 md-sm-xs-mt2 flex flex-column md-sm-xs-order-2 bold caps h7n">
              Numéro de chèque ou libellé du moyen de paiement*
              <input
                type="text"
                class="col-12 py1 px2 mt1 border-select"
                :class="{ 'red-bd' : !isReferenceValid(customPayment)}"
                :value="isReferenceDisable(customPayment) ? '' : customPayment.reference"
                :disabled="isReferenceDisable(customPayment)"
                required
                @input="event => customPayment.reference = event.target.value"
              >
            </label>

            <label class="col-2 lg-col-2 md-col-2 sm-col-6 pl2 flex flex-column bold caps h7n">
              Montant*
              <div class="relative">
                <input
                  v-model="customPayment.amount"
                  type="number"
                  class="col-12 py1 px2 mt1 border-select"
                  :class="{ 'red-bd' : !isAmountValid(customPayment.amount)}"
                  min="0"
                  required
                >
                <span class="absolute input-icon regular">€</span>
              </div>
            </label>

            <Button
              class="ml2 md-sm-xs-absolute top-0 right-0"
              :disabled="customPayments.length === 1"
              :color="`circle md-sm-xs-transparent-bg ${ (customPaymentIndex % 2 ) !== 0 ? 'white-bg' : 'lighter-grey-bg' }`"
              icon="icon-cancel flex h5 red"
              :action="() => removeCustomPayment(customPaymentIndex)"
            />
          </section>
        </div>

        <section v-if="!isFormValid" class="block alert no-box col-12 p1 flex flex-row border-top red lighter-grey-bg">
          <i class="icon mr2 ml1 red icon-stop"></i> Veuillez corriger les erreurs
        </section>

        <!-- ACTIONS -->
        <section class="pr3 md-sm-xs-pr0 flex justify-end items-stretch md-sm-xs-flex-column invert">
          <h4 class="mt2 mb1 mr2 md-sm-xs-mr0 md-sm-xs-order-2 md-sm-xs-center h5">
            Reste à payer :
            <strong
              class="ml1 h3"
              :class="{ 'red' : typePaymentsPriceRemaining !== 0 }"
            >{{ typePaymentsPriceRemaining.toFixed(2) }} €</strong>
          </h4>
          <Button :disabled="typePaymentsPriceRemaining <= 0" color="green-bg full-min-height" text="Ajouter un paiement" :action="addCustomPayment" />
        </section>

        <section class="mt2 mx3 flex justify-end">
          <Button :action="() => $emit('hide-popup')" text="Annuler" />
          <Button
            v-if="!loading"
            :disabled="!isFormValid || typePaymentsPriceRemaining !== 0"
            class="ml2"
            color="black-bg"
            text="Enregistrer le paiement"
            :action="emitNormalizedData"
          />
          <Button
            v-else
            :disabled="true"
            class="col-4 ml2"
            icon="icon icon-loader"
          />
        </section>
      <!-- END ACTIONS -->
      </section>
    <!-- END BODY -->
    </section>
  </Popup>
</template>

<script>
import Button from '@/components/elements/Button.vue';

import Popup from '@/components/elements/Popup.vue';

export default {
  name: 'CartRecapCustomPayments',
  components: {
    Button,
    Popup
  },
  props: {
    totalPrice: {
      type: String,
      default: null
    },
    discountPrice: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      customPaymentMethods: [
        { text: 'Cash', value: 'c6', reference: false },
        { text: 'Chèque', value: 'c7', reference: true },
        { text: 'TPE', value: 'c16', reference: false },
        { text: 'Autres', value: 'c8', reference: true }
      ],
      customPayments: [],
      showCustomPayments: false,
      loading: false
    };
  },
  computed: {
    showPromotion () {
      const price = parseFloat(this.totalPrice);
      return this.discountPrice < price;
    },
    isMethodSelected () {
      return method => method;
    },
    isReferenceValid () {
      return customPayment => {
        if (customPayment.method) {
          if (!this.isReferenceAllowed(customPayment.method)) return true;
          return customPayment?.reference && customPayment.reference.length;
        }
        return false;
      };
    },
    isFormValid () {
      // All fields are required
      return !this.customPayments.some(customPayment => !this.isMethodSelected(customPayment.method) || !this.isAmountValid(customPayment.amount) || !this.isReferenceValid(customPayment));
    },
    typePaymentsTotalPrice () {
      return this.customPayments.reduce((acc, customPayment) => acc + Number(customPayment.amount), 0).toFixed(2);
    },
    typePaymentsPriceRemaining () {
      return parseFloat(this.discountPrice - this.typePaymentsTotalPrice);
    }
  },
  mounted () {
    this.addCustomPayment();
  },
  methods: {
    isAmountValid (amount) {
      return parseFloat(this.totalPrice) === 0 || this.discountPrice === 0 ? amount >= 0 : amount > 0;
    },
    isReferenceDisable (payment) {
      const customPay = this.customPaymentMethods.find(p => p.value === payment.method);
      return !(customPay && customPay.reference);
    },
    addCustomPayment () {
      this.customPayments.push({
        method: null,
        amount: null,
        reference: null
      });
    },
    removeCustomPayment (customPaymentIndex) { this.customPayments.splice(customPaymentIndex, 1); },
    isReferenceAllowed (method) { return this.customPaymentMethods.find(customPaymentMethod => customPaymentMethod.value === method).reference; },
    emitNormalizedData () {
      this.loading = true;
      this.$emit('handle-pay', this.customPayments.map(customPayment => ({
        reference: !this.isReferenceAllowed(customPayment.method) ? null : customPayment.reference,
        method: customPayment.method,
        amount: Math.round(customPayment.amount * 100)
      })), true);
    }
  }
};
</script>

<style>
.input-icon {
  right: 6px;
  bottom: 6px;
}
</style>
